<template>
  <div class="top-info">
    <div class="row no-gutters">
      <div class="col-4">
        <p v-html="HOME_STEP1"></p>
      </div>
      <div class="col-4">
        <p v-html="HOME_STEP2"></p>
      </div>
      <div class="col-4">
        <p v-html="HOME_STEP3"></p>
      </div>
    </div>
    <div
      id="creaViaggioAncor"
      class="orange-area cursor-pointer"
      @click="onClick"
    >
      <span>Crea il tuo viaggio</span>
    </div>
    <a
      href="https://www.qualitygroup.it/"
      target="_blank"
      class="logo-sx image-contain"
    ></a>
    <a
      v-if="LOGO_EXTERNAL_1 !== undefined"
      :href="LOGO_EXTERNAL_1"
      :target="LOGO_EXTERNAL_1 != 'javascript:void(0);' ? '_blank' : '_self'"
      class="logo1 image-contain"
    ></a>
    <!--a  v-if="LOGO_EXTERNAL_2 !== undefined" :href="LOGO_EXTERNAL_2" :target="LOGO_EXTERNAL_2 != 'javascript:void(0);' ? '_blank' : '_self'" class="logo2 image-contain"></a-->
    <a
      v-if="LOGO_EXTERNAL_3 !== undefined"
      :href="LOGO_EXTERNAL_3"
      :target="LOGO_EXTERNAL_3 != 'javascript:void(0);' ? '_blank' : '_self'"
      class="logo3 image-contain"
    ></a>
    <div class="text-logo text-uppercase">Un progetto</div>
    <a
      :href="TOP_LINK_CHI_SIAMO_URL"
      target="_blank"
      class="logo-dx image-contain"
    ></a>
  </div>
</template>

<script>
import AnalyticEvents from "../../../common/AnalyticEvents";
import ContentUtils from "../../../utils/ContentUtils";

export default {
  name: "InfoArea",
  mixins: [AnalyticEvents, ContentUtils],
  methods: {
    onClick() {
      this.trackHomeCreaIlTuoViaggio();
      this.$scrollTo("#productAreaId", 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/home/InfoArea.vue